var Actions;

import ResponseCreateMemberModal from 'trunks/vue/admin/compositions/organizations/responses/create_member_modal.js';

import AddMembersModal from 'trunks/vue/admin/compositions/organizations/responses/add_members_modals/add_members_modal.js';

import ImportUsersModal from 'trunks/vue/admin/compositions/organizations/responses/import_users_modal.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import TagsSelect from 'trunks/vue/admin/compositions/tags_select.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default Actions = Vue.extend({
  props: {
    options: {
      type: Array
    },
    selectedRows: {
      type: Array,
      default: function() {
        return [];
      }
    },
    refreshDataAfterOperation: {
      type: Function
    },
    organization: {
      type: Object
    },
    profileSchema: {
      type: Object
    }
  },
  components: {
    'Popover': Popover,
    'tags-select': TagsSelect
  },
  data: function() {
    return {
      exportOption: 'current_organization',
      tagsRequestUrl: "/tag_groups/user",
      userProfileSchema: new Skylark.App.Model.UserProfile.Schema(this.profileSchema)
    };
  },
  template: `<div class="actions" ref="actions">
  <div class="btn text-btn btn-primary mr-5" v-if="_getEnabledOption('new')" @click="openResponseCreateMemberModal">
    <i class="slp-plus-circle"></i>
    <span>新建成员</span>
  </div>
  <div class="btn text-btn btn-primary mr-5" v-if="_getEnabledOption('add')" @click="openAddMembersModal">
    <i class="slp-plus-circle"></i>
    <span>添加成员</span>
  </div>
  <div class="btn text-btn btn-primary mr-5" v-if="_getEnabledOption('import')" @click="openResponseImportMemberModal">
    <i class="slp-download-o"></i>
    <span>导入成员</span>
  </div>

  <Popover position='bottom center' v-if="_getEnabledOption('export')" :customClass='"table-export-confirm-popover confirm"' ref="exportConfirmPopoverRef">
    <template slot='trigger'>
      <div class="btn text-btn btn-primary mr-5" >
        <i class="slp-upload-o"></i>
        <span>导出全部成员</span>
      </div>
    </template>
    <template slot='content'>
      <div class="popover-confirm-content">
        <div class="popover-confirm-title">导出全部成员</div>
        <div class="popover-confirm-body">确定导出全部成员信息？</div>
        <div class="popover-confirm-footer">
          <span class="btn btn-small btn-default outlined" @click="exportConfirmPopoverCancel">取消</span>
          <span class="btn btn-small btn-primary" @click="exportUsers">确定</span>
        </div>
      </div>
    </template>
  </Popover>
  <Popover position='bottom center' v-if="_getEnabledOption('export')" :customClass='"table-export-confirm-popover confirm"' ref="exportConfirmPopoverRef">
    <template slot='trigger'>
      <div class="btn text-btn btn-primary mr-5" >
        <i class="slp-upload-o"></i>
        <span>导出全部组织</span>
      </div>
    </template>
    <template slot='content'>
      <div class="popover-confirm-content">
        <div class="popover-confirm-title">导出全部组织</div>
        <div class="popover-confirm-body">确定导出全部组织信息？</div>
        <div class="popover-confirm-footer">
          <span class="btn btn-small btn-default outlined" @click="exportConfirmPopoverCancel">取消</span>
          <span class="btn btn-small btn-primary" @click="exportOrganizations">确定</span>
        </div>
      </div>
    </template>
  </Popover>
  <div v-if="_getEnabledOption('tags')" >
    <div class="btn text-btn btn-primary disabled" v-if="!rows.length">
      <i class="slp-label-o"></i>
      <span>批量添加标签</span>
    </div>
    <Popover position='bottom center' :customClass='"tags-popover popover-default select"' ref="addTagsConfirmPopoverRef" v-else>
      <template slot='trigger'>
        <div class="btn text-btn btn-primary" >
          <i class="slp-label-o"></i>
          <span>批量添加标签</span>
        </div>
      </template>
      <template slot='content'>
        <tags-select :optionsUrl='tagsRequestUrl'
                     :initialSelectedTagIds='selectedTagIds'
                     @submitClicked='updateOrganizationsTags'
                     @cancelClicked='tagsSelectCancel'
                     ref='tagsSelectRef'>
        </tags-select>
      </template>
    </Popover>
  </div>
</div>`,
  computed: {
    rows: function() {
      return _.filter(this.selectedRows, function(row) {
        return row.id;
      });
    },
    selectedTagIds: function() {
      var tag_ids;
      tag_ids = _.chain(this.rows).map(function(row) {
        return _.map(row.record.tags, function(tag) {
          return tag.id;
        });
      }).value();
      return _.intersection(...tag_ids);
    },
    selectedTags: function() {
      return _.chain(this.rows).map(function(row) {
        return _.map(row.record.tags, function(tag) {
          return tag;
        });
      }).flatten().uniq(false, function(tags) {
        return tags.id;
      }).value();
    }
  },
  methods: {
    openResponseCreateMemberModal: function() {
      return this.responseCreateMemberModal = new ResponseCreateMemberModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('response_create_member_modal_container'),
        propsData: {
          title: '编辑成员',
          tagsRequestUrl: this.tagsRequestUrl,
          profileSchema: this.userProfileSchema,
          createUserCallback: (data) => {
            return this.createUsersRequestFunc(data);
          }
        }
      });
    },
    openResponseImportMemberModal: function() {
      return new ImportUsersModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('response_import_member_modal_container')
      });
    },
    openAddMembersModal: function() {
      return this.addMembersModal = new AddMembersModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add_member_to_organization_modal_container'),
        propsData: {
          organization: this.organization,
          addMembersCallback: (members) => {
            return this.addMembers(members);
          }
        }
      });
    },
    exportConfirmPopoverCancel: function() {
      return this.$refs.exportConfirmPopoverRef.close();
    },
    createUsersRequestFunc: function(user) {
      return Skylark.Libs.Ajax.post('/admin/users', {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: user,
        success: () => {
          newAlertify('添加成功', {
            type: 'success'
          });
          this.responseCreateMemberModal.cancel();
          return this.refreshDataAfterOperation();
        },
        error: function(xhr, status, data) {
          var error_message;
          error_message = _.map(data, function(value, key) {
            return `${Skylark.Helpers.getZH_CN('message.' + key)}${value[0]}`;
          });
          return newAlertify('添加失败', {
            type: 'error',
            description: error_message.join(',')
          });
        }
      });
    },
    exportUsers: function() {
      return Skylark.Libs.Ajax.get("/admin/users/export", {
        contentType: 'application/json; charset=utf-8',
        success: () => {
          newAlertify('已成功添加导出任务', {
            type: 'success'
          });
          return this.exportConfirmPopoverCancel();
        },
        error: function() {
          return newAlertify('添加导出任务失败', {
            type: 'error'
          });
        }
      });
    },
    exportOrganizations: function() {
      return Skylark.Libs.Ajax.get("/admin/organizations/export", {
        contentType: 'application/json; charset=utf-8',
        success: () => {
          newAlertify('已成功添加导出任务', {
            type: 'success'
          });
          return this.exportConfirmPopoverCancel();
        },
        error: function() {
          return newAlertify('添加导出任务失败', {
            type: 'error'
          });
        }
      });
    },
    addMembers: function(members) {
      var member_ids;
      member_ids = _.map(members, function(member) {
        return member.id;
      });
      return Skylark.Libs.Ajax.put(`/admin/organizations/${this.organization.id}/members/add`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          member_ids: member_ids
        },
        success: () => {
          newAlertify('添加成员成功', {
            type: 'success'
          });
          this.addMembersModal.cancel();
          return this.refreshDataAfterOperation();
        },
        error: function() {
          return newAlertify('添加成员失败', {
            type: 'error'
          });
        }
      });
    },
    updateOrganizationsTags: function(selectedOptionTagIds, selectedOptionTags) {
      var deleted_option_tags, deleted_tag_ids;
      deleted_tag_ids = _.difference(this.selectedTagIds, selectedOptionTagIds);
      deleted_option_tags = _.filter(this.selectedTags, function(tag) {
        return _.contains(deleted_tag_ids, tag.id);
      });
      this.spinner = newSpinner({
        parent: this.$refs.actions
      });
      return Skylark.Libs.Ajax.put('/admin/users/tags', {
        contentType: 'application/json; charset=utf-8',
        data: {
          taggings: {
            remove_tag_ids: deleted_tag_ids,
            add_tag_ids: selectedOptionTagIds,
            user_ids: _.map(this.rows, function(row) {
              return row.id;
            })
          }
        },
        success: () => {
          var updateTagsOptions;
          Skylark.Bridge.newAlertify('操作成功', {
            type: 'success'
          });
          this.tagsSelectCancel();
          updateTagsOptions = {
            selectedOptionTags: selectedOptionTags,
            deletedOptionTags: deleted_option_tags
          };
          return this.$emit("refreshSeletedRowsTags", updateTagsOptions);
        },
        error: function() {
          return Skylark.Bridge.newAlertify('操作失败', {
            type: 'error'
          });
        },
        complete: () => {
          var ref;
          return (ref = this.spinner) != null ? ref.close() : void 0;
        }
      });
    },
    tagsSelectCancel: function() {
      return this.$refs.addTagsConfirmPopoverRef.close();
    },
    _getEnabledOption: function(option) {
      return _.contains(this.options, option);
    }
  }
});
